export default __webpack_public_path__ + "static/media/8.05f11044.png";